import { manageCatgoryConstants } from "../actions/constants/manageCategoryConstants";

type ManageCategoryDataState = {
	items: any[];
};

const initialManageCategorysData: ManageCategoryDataState = {
	items: [],
};

const manageCategoryData = (
	state = initialManageCategorysData,
	action: any
) => {
	switch (action.type) {
		// Use for get category list & serach result
		case manageCatgoryConstants.ManageCategoryGetByfilterRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
			};
		case manageCatgoryConstants.ManageCategoryGetByfilterSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isListSuccess: true,
				items: action.payload,
			};
		case manageCatgoryConstants.ManageCategoryGetByfilterFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isListSuccess: true,
				status: action.payload,
			};

		// Use to update the category status
		case manageCatgoryConstants.ManageCategoryUpdateStatusRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isFormSubmit: true,
				isUpdateStatus: false,
			};
		case manageCatgoryConstants.ManageCategoryUpdateStatusSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isUpdateStatus: true,
				isFormSubmit: false,
				status: action.payload.status,
			};
		case manageCatgoryConstants.ManageCategoryUpdateStatusFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUpdateStatus: true,
				isFormSubmit: false,
				status: action.payload.status,
			};

		// Use to create the category status
		case manageCatgoryConstants.ManageCategoryCreateRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isFormSubmit: true,
				isUpdateStatus: false,
			};
		case manageCatgoryConstants.ManageCategoryCreateSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isUpdateStatus: true,
				isFormSubmit: false,
				status: action.payload.status,
			};
		case manageCatgoryConstants.ManageCategoryCreateFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUpdateStatus: true,
				isFormSubmit: false,
				status: action.payload.status,
			};

		// Use to update the category status
		case manageCatgoryConstants.ManageCategoryUpdateRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isFormSubmit: true,
				isUpdateStatus: false,
			};
		case manageCatgoryConstants.ManageCategoryUpdateSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isUpdateStatus: true,
				isFormSubmit: false,
				status: action.payload.status,
			};
		case manageCatgoryConstants.ManageCategoryUpdateFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUpdateStatus: true,
				isFormSubmit: false,
				status: action.payload.status,
			};
		// Use to Delete the category status
		case manageCatgoryConstants.ManageCategoryDeleteRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case manageCatgoryConstants.ManageCategoryDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDeleteCompleted: true,
				status: action.payload.status,
			};
		case manageCatgoryConstants.ManageCategoryDeleteFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDeleteCompleted: true,
				status: action.payload.status,
			};
		default:
			return state;
	}
};

export default manageCategoryData;
